export const ConsoleLogged = 'sos.Monitoring.Console.ConsoleLogged';
export interface ConsoleLogged {
	type: typeof ConsoleLogged;
	level: 'log' | 'debug' | 'info' | 'warn' | 'error';
	messages: unknown[];
}
